import { users } from '../firebase/Collections';

export const updateUISettings = (uid, profile, key, value) => {
    users.doc(uid).update({
        ...profile,
        settings: {
            ...profile.settings,
            [key]: value
        }
    })
}